import React, { FC, Fragment, useContext } from 'react'
import { Context } from '../../../context'
import DatePickerSearch from './DatePickerSearch'
import { IsearchTools } from './SeacrhToolTypes/SearchTools.type'
import DropDownSearch from './DropDownSearch'
import Field from 'src/component/field'

const SEARCH_OBJECT = 1

const SearchTools: FC<IsearchTools> = ({ children, haveCustomPriority, onlyCustom }) => {

    const { searchData, setSearchData, searchTypes } = useContext(Context)

    return (
        < div className='row'>
            {haveCustomPriority && children}

            {searchData &&
                searchData?.map((field: any, index: number) => (
                    <Fragment key={index}>
                        <Field
                            searchField
                            className={'col-lg-3 col-md-6 col-sm-12'}
                            setValue={setSearchData}
                            value={field["value"]}
                            id={field["label"]}
                            name={field["label"]}
                            label={field["label"]}
                            placeholder={field["label"]}
                        />
                    </Fragment>
                ))
            }
            {/* Costume Searchs  */}
            {searchTypes &&
                Object.entries(searchTypes)?.map((customeField: any[], index) => (
                    <Fragment key={index}>
                        {
                            customeField[SEARCH_OBJECT].type == 'DropDown' &&
                            <Fragment key={`${customeField[SEARCH_OBJECT].Header}_${customeField[SEARCH_OBJECT].Header}_${index}`}>
                                <DropDownSearch
                                    className={"col-lg-3 col-md-6 col-sm-12"}
                                    ApiMethod={customeField[SEARCH_OBJECT]?.apiSource}
                                    selectFirst={customeField[SEARCH_OBJECT]?.selectFirst}
                                    isMulti={customeField[SEARCH_OBJECT].isMulti}
                                    accessor={customeField[SEARCH_OBJECT].accessor}
                                    depArr={customeField[SEARCH_OBJECT].depArr}
                                    Header={customeField[SEARCH_OBJECT].Header}
                                    optionList={customeField[SEARCH_OBJECT]?.options}
                                    probName={customeField[SEARCH_OBJECT]?.probName}
                                    sourceId={customeField[SEARCH_OBJECT]?.sourceId}
                                />
                            </Fragment>
                        }

                        {
                            customeField[SEARCH_OBJECT].type == 'Date' &&

                            <Fragment key={`${customeField[SEARCH_OBJECT].Header}_${customeField[SEARCH_OBJECT].Header}_${index}`}>
                                <DatePickerSearch
                                    className={"col-lg-3 col-md-6 col-sm-12"}
                                    isMulti={customeField[SEARCH_OBJECT].isMulti}
                                    Header={customeField[SEARCH_OBJECT].Header}
                                    accessor={customeField[SEARCH_OBJECT].accessor}
                                    probName={customeField[SEARCH_OBJECT]?.probName}
                                />
                            </Fragment>
                        }
                    </Fragment>
                )
                )
            }

            {!haveCustomPriority && children}
        </div >
    )
}

export default SearchTools